

import Vue from 'vue'
import { mapGetters } from 'vuex'
import ModalOverlay from '@/common/components/ModalOverlay.vue'
import Scene3DViewer from '@/common/components/Scene3DViewer.vue'
import { Product, SKU3DModel } from '@/model/product'

export default Vue.extend({
  name: 'Modal3DModel',
  components: {
    ModalOverlay,
    Scene3DViewer
  },
  computed: {
    ...mapGetters(['product']),
    getProduct(): Product  {
      // @ts-ignore
      return this.product
    },
    sku3dModel(): SKU3DModel {
      return this.getProduct.sku_three_d_model
    },
    modelUrl(): string {
      return this.sku3dModel.model_url
    },
    modelFormat(): string {
      return this.sku3dModel.model_format
    },
    modelTexture(): string {
      return this.getProduct.sku_three_d_background
    }
  },
  methods: {
    closeModal() {
      this.$emit('onClose')
    }
  }
})
